export const PRODUCT_VOLO_HOTEL = 1
export const PRODUCT_TOUR = 2
export const PRODUCT_EXPERIENCE = 3



// WEBPACK FOOTER //
// ./src/front/types/products.js